import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IHowitworks } from "../HowitworksModel";

export const getAllHowitworks = createAsyncThunk(
  "HowItWorks/FindAllHowItWorks",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/FindAllHowItWorks`,
        {
          CustomerName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Howitworks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createHowitworks = createAsyncThunk(
  "HowItWorks/InsertHowItWorks",
  async (HowitworksData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/InsertHowItWorks`,
        HowitworksData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Howitworks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateHowitworks = createAsyncThunk(
  "HowItWorks/UpdateHowItWorks",
  async (HowitworksData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/UpdateHowItWorks`,
        HowitworksData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Howitworks:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteHowitworks = createAsyncThunk(
  "HowItWorks/DeleteHowItWorks",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/DeleteHowItWorks`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Howitworks :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHowitworksByID = createAsyncThunk(
  "HowItWorks/FindByIDHowItWorks",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/FindByIDHowItWorks`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        ShortDescription: result.ShortDescription,
        SequenceNo: result.SequenceNo,
        Type: result.Type,
        IconImage: result.IconImage,
        MainImage: result.MainImage,
        IsActive: result.IsActive ? 1 : 2,
      } as IHowitworks;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveHowitworks = createAsyncThunk(
  "HowItWorks/FindAllActiveHowItWorks",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/HowItWorks/FindAllActiveHowItWorks`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveHowitworks = createAsyncThunk(
  "HowItWorks/ActiveInActiveHowItWorks",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/ActiveInActiveHowItWorks`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Howitworks :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const HowitworksImageUpload = createAsyncThunk(
  "HowItWorks/HowItWorksImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HowItWorks/HowItWorksImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Howitworks Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
